<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold tw-flex tw-items-center tw-gap-2">
  <svg class="tw-w-6 tw-h-6 tw-shrink-0">
    <use xlink:href="images/sprite.svg#info" />
  </svg>
  {{ styleInfo.title }}
</h2>
<div
  appGlossScroll
  mat-dialog-content
  class="tw-max-h-[70vh] tw-overflow-y-auto tw-min-w-[min(92vw,32rem)] tw-text-dt-text-headings"
>
  <ul class="tw-list-disc tw-pl-5 tw-space-y-3 tw-text-sm tw-m-0 tw-pb-2">
    @for (bullet of styleInfo.bullets; track $index) {
      <li>{{ bullet }}</li>
    }
  </ul>
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
